import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMBillingByPatientId (patientId) {
    const response = await _axios.get(
      `/ccmbilling/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Billing by patient ID');
  },
  async getCCMBillingByCCMRecordId (ccmRecordId) {
    try {
      const response = await _axios.get(
        `/ccmbilling/getbyccmrecordid/${ccmRecordId}`,
      );
      if (response.data.resFlag) {
        return response.data;
      }
      throw new CCMError('Error getting CCM Billing by CCM record ID');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return [];
      }
      throw new CCMError('Error getting CCM Billing by CCM record ID', error);
    }
  },
  async getCCMBilling (id) {
    const response = await _axios.get(`/ccmbilling/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Billing');
  },
};
